import * as React from 'react';
import { Component, ReactNode } from 'react';
import RichEditComponent, { RichEditComponentProps as ComponentProps }
    from 'src/modules/commons/inputs/rich-edit/RichEdit.component';

export interface RichEditProps {
    value?: string;
    placeholder?: string;
    uploadURL: string;
    disabled?: boolean;
    onChange: (value: string) => void;
}

interface InputState {
    value: string;
}

export default class RichEditContainer extends Component<RichEditProps, InputState> {

    private readonly id: string;

    constructor(props: RichEditProps) {
        super(props);
        this.state = {
            value: props.value || '',
        };

    }

    public componentWillReceiveProps(nextProps: RichEditProps) {
        this.setState({value: nextProps.value || ''});
    }

    public render(): ReactNode {
        return (
            <RichEditComponent {...this.getComponentProps()}/>
        );
    }

    private handleRichEditor(html: string, text: string): void {
        this.setState({
            value: html
        });
        this.props.onChange(html);
    }

    private getComponentProps(): ComponentProps {
        return {
            id: this.id,
            value: this.state.value,
            placeholder: this.props.placeholder,
            disabled: !!this.props.disabled,
            uploadURL: this.props.uploadURL,
            onChange: (html: string, text: string) => this.handleRichEditor(html, text),
        };
    }
}



// WEBPACK FOOTER //
// ./src/modules/commons/inputs/rich-edit/RichEdit.container.tsx